export class CashInquirySearchDto {
    invoiceNumber = '';
    referenceNumber = '';
    paidAmount = 0;
    paidDate = '';
    sort = 'default';
    pageNumber = 1;
    pageSize = 50;
}
